import { forAny, forBlock, setting, suggest, Suggestion, suggestMultiple } from "./PowerEditorSettingsSuggestions";

export const PowerEditorDefaultSuggestions: Suggestion[] = [
  suggest(forAny(),
    setting("_class")),
  suggest(forAny(),
    setting("_htmlid")),
  suggest(forAny(),
    setting("render_block_type")),
  
  suggest(forBlock("custom_fields_block"),
    setting("preconfigured_fields")),
  suggest(forBlock("configurable_table_block"),
    setting("preconfigured_fields")),
  suggest(forBlock("configurable_table_block"),
    setting("list_fields")),

  ...suggestMultiple(forBlock("table"),
    setting("width"),
    setting("columns_width", ["50%; 25%; 25%"]),
    setting("no_border")
  ),
] 